import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import {
  currentPageSelector,
  useFilteredBlacklistedLearners,
} from 'features/communicationManagement';
import PersonalisedMenteeEmailersPagination from '../PersonalisedMenteeEmailersPagination';
import PersonalisedMenteeEmailersTable from '../PersonalisedMenteeEmailersTable';

const ITEMS_PER_PAGE = 20;

export default function PersonalisedMenteeEmailersContent() {
  const currentPage = useSelector(currentPageSelector);

  const { data, isFetching, error } = useFilteredBlacklistedLearners();

  const calculatePageCount = useMemo(() => {
    const totalCount = data?.meta?.total_count || 0;
    return Math.ceil(totalCount / ITEMS_PER_PAGE);
  }, [data]);

  return (
    <>
      <PersonalisedMenteeEmailersTable
        blacklistedLearners={data?.data}
        blacklistedLearnersMeta={data?.meta}
        error={error}
        isLoading={isFetching}
      />
      {!isFetching && (
        <PersonalisedMenteeEmailersPagination
          currentPage={currentPage}
          pageCount={calculatePageCount}
        />
      )}
    </>
  );
}
